import "./index.scss";
import { StrictMode } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import App from "./App";

// redux
import { Provider } from "react-redux";
import { store, persistor } from "./store";
import { PersistGate } from "redux-persist/integration/react";

import { HelmetProvider } from "react-helmet-async";

// ga
import ReactGA from "react-ga4";

import reportWebVitals from "./reportWebVitals";
import { GA_TRACKING_ID } from "./utils";
if (GA_TRACKING_ID) ReactGA.initialize(GA_TRACKING_ID);
const container = document.getElementById("root") as HTMLElement;
const root = createRoot(container);
// root.render(
//   <StrictMode>
//     <Provider store={store}>
//         <HelmetProvider>
//             <App />
//         </HelmetProvider>
//     </Provider>
//   </StrictMode>,
// );

if (container.hasChildNodes()) {
  hydrateRoot(
    container,
    <Provider store={store}>
      <HelmetProvider>
        <PersistGate loading={null} persistor={persistor}>
          <App />
        </PersistGate>
      </HelmetProvider>
    </Provider>,
  );
} else {
  // StrictMode 는 개발 모드에서 useEffect 2번 호출하고 있음.
  root.render(
    // <StrictMode>
    <Provider store={store}>
      <HelmetProvider>
        <PersistGate loading={null} persistor={persistor}>
          <App />
        </PersistGate>
      </HelmetProvider>
    </Provider>,
    // </StrictMode>
  );
}
// ReactDOM.render(
// 	<StrictMode>
// 		<Provider store={store}>
// 			<App />
// 		</Provider>
// 	</StrictMode>,
// 	document.getElementById('root')
// );

reportWebVitals();
function isiOS() {
  return (
    ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(
      navigator.platform,
    ) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  );
}
if ("serviceWorker" in navigator) {
  // 서비스 워커 지원 확인
  if (isiOS()) {
    navigator.serviceWorker.getRegistrations().then(function (registrations) {
      for (const registration of registrations) {
        // console.log("serviceWorker unregistered");
        registration.unregister();
      }
    });
  } else {
    window.addEventListener("load", function () {
      // 브라우저 로드가 완료되면
      navigator.serviceWorker.register("/sw.js"); // 서비스 워커 등록
    });
  }
}
